export function normalizePhoneDigits(phone) {
  if (phone == null) return '';
  return String(phone).replace(/\D/g, '');
}

export function isPhoneOptedOut(phone, optedOutSet) {
  if (!phone || !optedOutSet || !(optedOutSet instanceof Set) || optedOutSet.size === 0) {
    return false;
  }
  const digits = normalizePhoneDigits(phone);
  if (!digits) return false;

  if (optedOutSet.has(digits)) return true;
  if (digits.length > 10 && optedOutSet.has(digits.slice(-10))) return true;
  if (digits.length === 10) {
    if (optedOutSet.has(`91${digits}`)) return true;
  }
  return false;
}

